import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
  REQUEST_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
  REQUEST_DELETE_USER_FROM_STAGE,
  REQUEST_ADD_USER_TO_STAGE,
} from '../../Redux/constants/constants';
import { Icon, Radio, Table, Tag } from 'antd';
import { VerticalMargin } from '../../Helper/VerticalMargin.Styles';
import FlexGroup from '../../Helper/FlexGroup.Styles';
import formatToCurrency from '../../Utils/formatToCurrency';

const { Column } = Table;

const UsersInStageTable = ({ stageId, activeKey, thisKey, userView }) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState('active');
  const usersInStage = useSelector((state) => state.usersInStage);
  const usersNotInStage = useSelector((state) => state.usersNotInStage);
  // TODO remove unused props
  // thsi components is in all tabs at the same time
  // but needst to display diferent data if it is in focus
  // that is why i dispatch action to fetch new data only in activeKey and thisKey is the same

  // TODO this useEffect is not neaded
  /*
  useEffect(() => {
    if (stageId && thisKey === activeKey) {
      dispatch({
        type: REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
        payload: stageId
      });
      !userView &&
        dispatch({
          type: REQUEST_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
          payload: stageId
        });
    }
  }, [stageId, activeKey, thisKey]);
/**/

  // const dataForAutoComplete = data =>
  //   data.map(item => <Option key={item.id}>{item.name}</Option>);

  const changeStatus = (value) => setStatus(value);

  // const onSelect = value => {
  //   dispatch({
  //     type: REQUEST_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
  //     payload: value
  //   });
  // };

  const modifyUserInStage = (userId, status) => {
    switch (status) {
      case 'active':
        dispatch({
          type: REQUEST_DELETE_USER_FROM_STAGE,
          payload: { stageId, userId },
        });
        break;
      case 'inactive':
        dispatch({
          type: REQUEST_ADD_USER_TO_STAGE,
          payload: { stageId, userId },
        });
        break;

      default:
        break;
    }
  };

  const deleteUserFromStage = () => {};

  return (
    <>
      {!userView && (
        <VerticalMargin>
          <FlexGroup>
            <Radio.Group
              value={status}
              onChange={(e) => changeStatus(e.target.value)}
            >
              <FlexGroup>
                <Radio.Button value="active">W projekcie</Radio.Button>
                <Radio.Button value="inactive">Dodaj pracownika</Radio.Button>
              </FlexGroup>
            </Radio.Group>
          </FlexGroup>
        </VerticalMargin>
      )}

      <Table
        rowKey={(record) => record.id}
        dataSource={status === 'active' ? usersInStage : usersNotInStage}
        pagination={false}
      >
        <Column title="Imię i Nazwisko" dataIndex="name" key="name" />
        <Column
          title="Ilość godzin w ostatnim miesiącu"
          dataIndex="sumLastMonth"
          key="sumLastMonth"
        />
        <Column
          title="Całkowita ilość godzin"
          dataIndex="sumTotal"
          key="sumTotal"
        />
        {/*<Column*/}
        {/*  title="Role"*/}
        {/*  dataIndex="role"*/}
        {/*  key="role"*/}
        {/*  render={tag => (*/}
        {/*    <span>*/}
        {/*      <Tag color="blue" key={tag}>*/}
        {/*        {tag}*/}
        {/*      </Tag>*/}
        {/*    </span>*/}
        {/*  )}*/}
        {/*/>*/}
        {!userView && (
          <Column
            title="Całkowity koszt"
            dataIndex="totalCost"
            key="totalCost"
            render={(value) => {
              return <span>{formatToCurrency(value)}</span>;
            }}
          />
        )}
        {!userView && (
          <Column
            title=" "
            key="action"
            render={(record) => (
              <a
                onClick={() => {
                  modifyUserInStage(record.id, status);
                }}
              >
                {status === 'active' ? (
                  <>
                    <Icon type="delete" theme="twoTone" />
                    <span> Usuń</span>
                  </>
                ) : (
                  <>
                    <Icon type="plus-circle" theme="twoTone" />
                    <span> Dodaj</span>
                  </>
                )}
              </a>
            )}
          />
        )}
      </Table>
    </>
  );
};

export default UsersInStageTable;
